module.exports = __webpack_public_path__ + "static/img/join_sup.edeac18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/join_sup.png
// module id = Kl3u
// module chunks = 1